var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rating",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73617 1.78337L8.95445 4.2172C9.07384 4.45614 9.30431 4.62181 9.57157 4.66015L12.2969 5.05244C12.9702 5.14966 13.2382 5.96573 12.7509 6.43333L10.7801 8.32699C10.5864 8.51321 10.4983 8.7809 10.5441 9.04379L11.0092 11.7172C11.1237 12.3786 10.4198 12.8832 9.818 12.5703L7.38214 11.3072C7.14335 11.1832 6.85735 11.1832 6.61786 11.3072L4.182 12.5703C3.58015 12.8832 2.87626 12.3786 2.9915 11.7172L3.4559 9.04379C3.50171 8.7809 3.41355 8.51321 3.21988 8.32699L1.24912 6.43333C0.76181 5.96573 1.02976 5.14966 1.70311 5.05244L4.42843 4.66015C4.69569 4.62181 4.92685 4.45614 5.04625 4.2172L6.26383 1.78337C6.5651 1.18159 7.4349 1.18159 7.73617 1.78337Z",
    stroke: "#23273B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.0cbc1c9edb592c44b26d7fa237f00c53.svg";
export { ForwardRef as ReactComponent };